// 分享论文解读：复制公开链接。网站免登录公开访问，任何拿到链接的人都能看。
import { copyText, showToast } from './ui';

export async function shareArticle(articleId) {
  const url = `${window.location.origin}/article/${articleId}`;
  const ok = await copyText(url);
  showToast(
    ok
      ? '公开链接已复制到剪贴板\n任何拥有此链接的人都可查看此论文解读'
      : '复制失败，请手动复制浏览器地址栏链接',
    ok
  );
}
